module.exports = __webpack_public_path__ + "img/cat-green.6e487eef.svg";